import React, { useState, useEffect } from "react";
import {
  Text,
  Pressable,
  Platform,
  Keyboard,
  ActivityIndicator,
  View,
} from "react-native";

interface ButtonProps {
  label: string;
  onClick?: () => void;
  blocked?: boolean;
  isLoading?: boolean;
}

export default function Button(props: ButtonProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter" && props.onClick) {
      props.onClick();
    }
  };

  useEffect(() => {
    if (Platform.OS === "web") {
      window.addEventListener("keydown", handleKeyPress);
    } else if (Platform.OS === "ios" || Platform.OS === "android") {
      Keyboard.addListener("keyboardDidShow", handleKeyPress);
      Keyboard.addListener("keyboardDidHide", handleKeyPress);
    }

    return () => {
      if (Platform.OS === "web") {
        window.removeEventListener("keydown", handleKeyPress);
      } else if (Platform.OS === "ios" || Platform.OS === "android") {
        Keyboard.removeAllListeners("keyboardDidShow");
        Keyboard.removeAllListeners("keyboardDidHide");
      }
    };
  }, [props.onClick]);

  const handleClick = () => {
    if (!props.blocked) {
      props.onClick();
    }
  };

  return (
    <View className="w-80 h-14 p-0.5 m-4 items-center">
      {props.isLoading ? (
        <ActivityIndicator size="large" color="#5D0CBA" />
      ) : (
        <Pressable
          className={`transition-colors delay-100 items-center justify-center w-80 h-14 rounded p-2 ${
            props.blocked ? "bg-midgray" : "bg-purple1"
          } ${isHovered && !props.blocked ? "bg-purple3" : ""}`}
          onPress={handleClick}
          onHoverIn={() => (props.blocked ? null : setIsHovered(true))}
          onHoverOut={() => (props.blocked ? null : setIsHovered(false))}
        >
          <Text className="text-white font-normal text-lg">{props.label}</Text>
        </Pressable>
      )}
    </View>
  );
}
